import gql from 'graphql-tag';

const SAVE_PROGRESS = gql`
  mutation($input: JSON!) {
    saveProgress(input: $input)
  }
`;

const ERASE_DEMO_DATA = gql`
  mutation {
    clearDemoData
  }
`;

export { SAVE_PROGRESS, ERASE_DEMO_DATA };
